import { METRICTYPE } from 'src/utils/entityDefinitions';

export interface SegmentChartData {
  primaryData: number[][];
  secondaryData: number[][];
}

export interface SegmentLegendData {
  formattedPrimaryTotal: string;
  percentChange: number;
  metricType: METRICTYPE;
}

export interface TransformedSegmentData {
  chartData: SegmentChartData;
  legendData: SegmentLegendData;
}

export class AtlasSegmentDataAdapter {
  private rawData: any;
  private fieldName: string;
  private formatter: (value: number, metricType: METRICTYPE, options?: any) => string;
  private comparisonTimePeriod: any;

  constructor(
    rawData: any,
    fieldName: string,
    formatter: (value: number, metricType: METRICTYPE, options?: any) => string,
    comparisonTimePeriod: any
  ) {
    this.rawData = rawData;
    this.fieldName = fieldName;
    this.formatter = formatter;
    this.comparisonTimePeriod = comparisonTimePeriod;
  }

  transform(): TransformedSegmentData {
    const {
      primaryData: hookPrimaryData,
      secondaryData: hookSecondaryData,
      primaryTotal,
      percentChange: hookPercentChange
    } = this.rawData;

    const mainData = hookPrimaryData || [];
    let compData = hookSecondaryData || [];

    if (
      this.comparisonTimePeriod.id === 'prior-year' &&
      mainData.length > 0 &&
      compData.length > 0 &&
      mainData.length === compData.length &&
      mainData[0][0] !== compData[0][0]
    ) {
      compData = compData.map((dataPoint, index) => {
        if (mainData[index]) {
          return [mainData[index][0], dataPoint[1]];
        }
        return dataPoint;
      });
    }

    const formattedPrimaryTotal = this.formatter(
      primaryTotal,
      this.fieldName === 'retailSales' ? METRICTYPE.MONEY : METRICTYPE.VOLUME,
      { decimalPlaces: 2, showFullValue: false }
    );

    return {
      chartData: {
        primaryData: mainData,
        secondaryData: compData
      },
      legendData: {
        formattedPrimaryTotal,
        percentChange: hookPercentChange,
        metricType: this.fieldName === 'retailSales' ? METRICTYPE.MONEY : METRICTYPE.VOLUME
      }
    };
  }

  hasValidData(): boolean {
    return !!(this.rawData.response?.primary && !this.rawData.isLoading);
  }

  isLoading(): boolean {
    return this.rawData.isLoading;
  }
}
